import { combineReducers } from 'redux';
import { inlineClientForm } from './InlineClient/store/reducer';
import UDVAppAdvocacyBanner from './UDVAppAdvocacyBanner/reducer';

export const calendar = combineReducers({
  inlineClientForm,
  UDVAppAdvocacyBanner,
});
